

























































































































































































































































































































































































































































































































import { Vue } from "vue-property-decorator";

export default Vue.extend({
  components: {
    "stat-view": () => import("@/components/app/global/stats/stat/statView.vue")
  },
  data() {
    return {
      radioBox: "bank_transfer",
      availableBillingTerms: [
        {
          leftLabel: "Pay monthly",
          rightLabel: "£20"
        },
        {
          leftLabel: "Pay every 6 months",
          rightLabel: "£150"
        },
        {
          leftLabel: "Pay every year",
          rightLabel: "£300"
        }
      ],
      selectedBillingTerm: null,
      availableOptions: [
        {
          leftLabel: "100% cotton robe",
          rightLabel: "+£19.99",
          desc:
            "Our range are made from the finest quality materials to ensure they have not only excellent absorbency properties but are also super-soft on your skin."
        },
        {
          leftLabel: "Slippers",
          rightLabel: "+9.99",
          desc: "Our luxury slippers are only available online."
        },
        {
          rightLabel: "+£1.99",
          leftLabel: "Cleansing kit"
        }
      ],
      selectedOption: 2,
      selectedOptions: [1]
    };
  },
  methods: {
    onClick(vm) {
      // Do Something
    }
  }
});
